import { render, staticRenderFns } from "./cardTest.vue?vue&type=template&id=4c2a07d2&scoped=true&"
import script from "./cardTest.vue?vue&type=script&lang=js&"
export * from "./cardTest.vue?vue&type=script&lang=js&"
import style0 from "./cardTest.vue?vue&type=style&index=0&id=4c2a07d2&prod&lang=scss&scoped=true&"
import style1 from "./cardTest.vue?vue&type=style&index=1&id=4c2a07d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2a07d2",
  null
  
)

export default component.exports